
// Import Swiper core and required modules
import Swiper, { Navigation, Pagination } from 'swiper';

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';

document.addEventListener('DOMContentLoaded', () => {
    // Select all Swiper containers with the class 'image-carousel'
    document.querySelectorAll('.image-carousel .swiper').forEach((swiperElement) => {
        // Find the specific navigation buttons within the same parent container
        const parent = swiperElement.closest('.image-carousel');
        const nextButton = parent.querySelector('.custom-arrow-next');
        const prevButton = parent.querySelector('.custom-arrow-prev');

        // Initialize Swiper for each element
        new Swiper(swiperElement, {
            modules: [Navigation, Pagination],
            slidesPerView: 1.5,
            spaceBetween: 0,
            breakpoints: {
                640: { slidesPerView: 2.5 },
                1024: { slidesPerView: 3.5 },
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            loop: true,
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".custom-products-swiper")) {
        new Swiper(".custom-products-swiper", {
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }
});